export const getLdwExcessDisplay = (selectedCar: any): string => {
  const currency = selectedCar?.currency;
  const ldw = selectedCar?.basic_insurance?.find((i: any) => i?.code === "LDW");
  const excess = ldw?.excess;

  if (!currency || excess === null || excess === undefined || Number.isNaN(Number(excess))) return "-";
  return `${currency} ${Number(excess).toFixed(2)}`;
};
